import { AppEnv } from '@/types/enum';
import joyCsTextLogo from './logo/joy-cs-text-logo.png';
import joyScrmTextLogo from './logo/joy-scrm-text-logo.png';

export const ALL_APP_CONFIGS: {
  [key in string]: {
    key: string;
    name: string;
    url: { [key in AppEnv]?: string };
    envName?: { [key in AppEnv]?: string };
    logo?: string;
    header: 'system' | 'custom';
  };
} = {
  scrm: {
    key: 'scrm',
    name: 'SCRM',
    url: {
      [AppEnv.dev]: 'http://localhost:12138',
      [AppEnv.ready]: 'https://urm-ready.huanle.com',
      [AppEnv.pre]: 'https://urm-pre.huanle.com',
      [AppEnv.prd]: 'https://scrm.123u.com',
    },
    logo: joyScrmTextLogo,
    header: 'custom',
  },
  joycs: {
    key: 'joycs',
    name: '客服系统',
    url: {
      [AppEnv.dev]: 'http://localhost:12580',
      [AppEnv.ready]: 'https://cs-ready.123u.com',
      [AppEnv.pre]: '',
      [AppEnv.prd]: '',
    },
    logo: joyCsTextLogo,
    header: 'system',
  },
  joypam: {
    key: 'joypam',
    name: 'JoyPAM',
    url: {
      [AppEnv.dev]: 'http://localhost:3000',
      [AppEnv.ready]: 'https://pam.123u.com',
      [AppEnv.pre]: 'https://pam.123u.com',
      [AppEnv.prd]: 'https://pam.123u.com',
    },
    header: 'custom',
  },
  // ad: {
  //   key: 'ad',
  //   name: '智投通',
  //   url: {
  //     [AppEnv.dev]: 'http://localhost:8000',
  //     [AppEnv.ready]: 'https://ad-ready.123u.com',
  //     [AppEnv.pre]: 'https://ad-pre.123u.com',
  //     [AppEnv.prd]: 'https://ad.123u.com',
  //   },
  // },
  // devops: {
  //   key: 'devops',
  //   name: '行云',
  //   url: {
  //     [AppEnv.dev]: 'http://localhost:8000',
  //     [AppEnv.ready]: 'https://devops-dev.123u.com',
  //     [AppEnv.pre]: 'https://devops-ready.123u.com',
  //     [AppEnv.prd]: 'https://devops.123u.com',
  //   },
  // },
};
